
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/agenda",
      function () {
        return require("private-next-pages/egypt/agenda.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/agenda"])
      });
    }
  